/* eslint-disable max-lines */
import { Table } from "antd"
import { ItemAutoComplete } from "../../../../../../../../_webui/layout/components/Form/Item/AutoComplete"
import { ItemInput } from "../../../../../../../../_webui/layout/components/Form/Item/Input"
import { ItemSelect } from "../../../../../../../../_webui/layout/components/Form/Item/Select"
import {
  ColumnType,
  UseTableConfigType,
} from "../../../../../../../../_webui/layout/components/Table/models"
import { GeneralCode } from "../../../../../../../../constant/GeneralCode"
import { Translate } from "../../../../../../../../constant/Translate"
import { validatorHalfSize } from "../../../../../../../../utils/validator/halfSize"
import { validatorRequiredField } from "../../../../../../../../utils/validator/requiredField"
import { UseTableDetailsConfigProps } from "../../../../../components/add/Form/ContentCollapse/Detail/models"
import { SchedulesAddDetailRow } from "../../../../../constants/add/addDetailRow"
import { ScheduleInfoDetailsType } from "../../../../../models/add"
import { setNameRowDetail } from "../../../utils/setNameRowDetail"
import { ItemTimePicker } from "../../../../../../../../_webui/layout/components/Form/Item/TimePicker"
import { ItemDatePicker } from "../../../../../../../../_webui/layout/components/Form/Item/DatePicker"
import { requiredField } from "../../../../../../../../utils/requiredField"
import { Styled } from "./styled"
import { ItemRadio } from "../../../../../../../../_webui/layout/components/Form/Item/Radio"

const {
  HELP_H0036,
  HELP_H0037,
  MESSAGE_E0158,
  MESSAGE_W0020,
  TEXT_T155,
  TEXT_T163,
  TEXT_T169,
  TEXT_T171,
  TEXT_T202,
  TEXT_T205,
  TEXT_T206,
  TEXT_T208,
  TEXT_T209,
  TEXT_T220,
  TEXT_T240,
  TEXT_T243,
  TEXT_T700,
  TEXT_T701,
  TEXT_T702,
  TEXT_T709,
  TEXT_T710,
} = Translate

const { OTHER, TPTT001 } = GeneralCode
const { ARRIVAL, DEPARTURE } = SchedulesAddDetailRow
const { SELECTION_COLUMN } = Table
const {
  StyledFlexItem,
  StyledFlexGroup,
  StyledFlex,
  StyledTitle,
  StyledTitleRight,
} = Styled

export const useTableDetailsConfig = (
  props: UseTableDetailsConfigProps,
): UseTableConfigType<ScheduleInfoDetailsType> => {
  const {
    allCountries,
    flightNumberList,
    onBlur,
    onBlurArrivalCityName,
    onChangeCity,
    onChangeCountry,
    onChangeDate,
    onChangeTransportation,
    onClearDepartureFlight,
    onKeyDown,
    onSelectDepartureFlight,
    onValidateChangeDate,
    transportationList,
  } = props

  const columns: ColumnType<ScheduleInfoDetailsType>[] = [
    {
      align: "center",
      render: (_, _data, index) => index + 1,
      title: TEXT_T240,
      width: 65,
    },
    SELECTION_COLUMN,
    {
      render: (_, data) => (
        <ItemInput
          isHidden
          isHiddenLabel
          label={TEXT_T243}
          name={`${setNameRowDetail(data.index)}.travelDetailId`}
        />
      ),
      title: <div className="d-none">{TEXT_T243}</div>,
      width: 0,
    },
    {
      render: (_, data, index) => {
        const arrivalName = `${setNameRowDetail(data.index)}.arrivalDate`
        const nameDepartureTime = `${setNameRowDetail(
          data.index,
        )}.departureTime`
        const departureName = `${setNameRowDetail(data.index)}.departureDate`
        const nameArrivalTime = `${setNameRowDetail(data.index)}.arrivalTime`

        return (
          <StyledFlex>
            <StyledFlexGroup>
              <StyledFlexItem>
                <ItemSelect
                  label={TEXT_T202}
                  name={`${setNameRowDetail(data.index)}.transportation`}
                  onChange={(value: string) =>
                    onChangeTransportation(value, index)
                  }
                  rules={[validatorRequiredField]}
                  selectItem={transportationList}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemAutoComplete
                  clearIndex={data.index}
                  label={TEXT_T700}
                  maxLength={100}
                  name={`${setNameRowDetail(data.index)}.departureFlightNumber`}
                  onClear={() =>
                    onClearDepartureFlight(data.travelDetailId, data.index)
                  }
                  onSelect={(value) =>
                    onSelectDepartureFlight(
                      value,
                      data.travelDetailId,
                      data.index,
                    )
                  }
                  options={flightNumberList}
                  rules={[
                    ...requiredField(data.transportation === TPTT001),
                    validatorHalfSize,
                  ]}
                />
              </StyledFlexItem>
              <StyledFlexItem $colSpan={3}>
                <ItemRadio
                  label={TEXT_T220}
                  name={`${setNameRowDetail(data.index)}.isTransit`}
                  radioItems={[
                    { text: TEXT_T709, value: 0 },
                    { text: TEXT_T710, value: 1 },
                  ]}
                />
              </StyledFlexItem>
            </StyledFlexGroup>
            <StyledFlexGroup>
              <StyledFlexItem>
                <ItemSelect
                  label={TEXT_T205}
                  name={`${setNameRowDetail(data.index)}.departureCountryCode`}
                  onChange={(value) =>
                    onChangeCountry(data.travelDetailId, value, DEPARTURE)
                  }
                  rules={[validatorRequiredField]}
                  selectItem={allCountries}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemSelect
                  label={TEXT_T206}
                  name={`${setNameRowDetail(data.index)}.departureCityCode`}
                  onChange={(value) =>
                    onChangeCity(data.travelDetailId, value, DEPARTURE)
                  }
                  rules={[validatorRequiredField]}
                  selectItem={data?.departureCities}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemInput
                  isDisabled={data.departureCityCode !== OTHER}
                  label={TEXT_T701}
                  maxLength={200}
                  name={`${setNameRowDetail(data.index)}.departureCityName`}
                  rules={requiredField(data.departureCityCode === OTHER)}
                  tooltip={HELP_H0036}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemDatePicker
                  label={TEXT_T155}
                  name={departureName}
                  onBlur={(event) => {
                    onBlur(event, TEXT_T155, departureName)
                    onValidateChangeDate()
                  }}
                  onChange={() => {
                    onValidateChangeDate()
                  }}
                  onKeyDown={(event) => {
                    onKeyDown(event, TEXT_T155, departureName)
                    if (event.keyCode === 13) onValidateChangeDate()
                  }}
                  rules={[validatorRequiredField]}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemTimePicker
                  label={TEXT_T163}
                  name={nameDepartureTime}
                  onBlur={(event) => {
                    onBlur(event, TEXT_T163, nameDepartureTime)
                    onChangeDate(departureName)
                  }}
                  onChange={() => {
                    onChangeDate(departureName)
                  }}
                  onKeyDown={(event) => {
                    onKeyDown(event, TEXT_T163, nameDepartureTime)
                    onChangeDate(departureName)
                  }}
                  rules={[validatorRequiredField]}
                />
              </StyledFlexItem>
            </StyledFlexGroup>
            <StyledFlexGroup>
              <StyledFlexItem>
                <ItemSelect
                  label={TEXT_T208}
                  name={`${setNameRowDetail(data.index)}.arrivalCountryCode`}
                  onChange={(value) =>
                    onChangeCountry(data.travelDetailId, value, ARRIVAL)
                  }
                  rules={[validatorRequiredField]}
                  selectItem={allCountries}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemSelect
                  label={TEXT_T209}
                  name={`${setNameRowDetail(data.index)}.arrivalCityCode`}
                  onChange={(value) =>
                    onChangeCity(data.travelDetailId, value, ARRIVAL)
                  }
                  rules={[validatorRequiredField]}
                  selectItem={data.arrivalCities}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemInput
                  isDisabled={data.arrivalCityCode !== OTHER}
                  label={TEXT_T702}
                  maxLength={200}
                  name={`${setNameRowDetail(data.index)}.arrivalCityName`}
                  onBlur={(event) =>
                    onBlurArrivalCityName(
                      event.currentTarget.value,
                      data.travelDetailId,
                    )
                  }
                  rules={requiredField(data.arrivalCityCode === OTHER)}
                  tooltip={HELP_H0037}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemDatePicker
                  label={TEXT_T169}
                  name={arrivalName}
                  onBlur={(event) => {
                    onBlur(event, TEXT_T169, arrivalName)
                    onValidateChangeDate()
                  }}
                  onChange={() => {
                    onValidateChangeDate()
                    onChangeDate(departureName)
                  }}
                  onKeyDown={(event) => {
                    onKeyDown(event, TEXT_T169, arrivalName)
                    if (event.keyCode === 13) onValidateChangeDate()
                  }}
                  rules={[validatorRequiredField]}
                />
              </StyledFlexItem>
              <StyledFlexItem>
                <ItemTimePicker
                  label={TEXT_T171}
                  name={nameArrivalTime}
                  onBlur={(event) => {
                    onBlur(event, TEXT_T171, nameArrivalTime)
                    onChangeDate(departureName)
                  }}
                  onChange={() => {
                    onChangeDate(departureName)
                  }}
                  onKeyDown={(event) => {
                    onKeyDown(event, TEXT_T171, nameArrivalTime)
                    onChangeDate(departureName)
                  }}
                  rules={[validatorRequiredField]}
                />
              </StyledFlexItem>
            </StyledFlexGroup>
          </StyledFlex>
        )
      },
      title: (
        <StyledTitle
          type="primary"
          titleLeft={MESSAGE_E0158}
          titleRight={<StyledTitleRight>{MESSAGE_W0020}</StyledTitleRight>}
        />
      ),
      width: "calc(100% - 131px)",
    },
  ]

  return {
    columns,
  }
}
